import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { PTSMasterScreen_ScreenContext } from "../ptsmasterscreen/ptsmasterscreen-context";

declare let window: any;

export interface ICatiGES_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ICatiGES_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class CatiGES_ScreenBase extends React.PureComponent<
  ICatiGES_ScreenProps,
  any
> {
  static contextType = PTSMasterScreen_ScreenContext;
  declare context: React.ContextType<typeof PTSMasterScreen_ScreenContext>;

  ml = [
    {
      Id: "08e1cb20-24ad-e190-d46b-beded98dd4ae",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4106607f-9ae3-47ff-8d8a-3ced44ab92c6",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "f0a0a2f7-de82-46af-97e3-706caadd2342",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "catiges",
        "ptsmasterscreen_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "catiges",
      "ptsmasterscreen_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "catiges",
      "ptsmasterscreen_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
